import { useEffect, useState } from 'react';

import { SiteLayoutComponent, SiteSection } from 'shared/components/site-layout';
import { LoadingComponent } from 'shared/components/loading';

import { SubscriptionService } from 'api/subscription';

import { SubscriptionSelectLayout } from './layout';
import { SubscriptionPlanViewModel, createPlansViewModels } from './model/subscriptions';
import { usePageMeta } from 'shared/mechanics/page-meta';

interface SubscriptionState {
	isLoaded: boolean;
	subscriptionPlans: SubscriptionPlanViewModel[];
}

export const SubscriptionSelectPage = () => {
	usePageMeta({
		title: 'Тарифные планы',
		description: 'расширенные возможности анализа биржевых фондов с подпиской Инвестор+',
		keyWords: ['цена', 'оплата', 'подписки', 'paywall'],
		canonicalPath: 'subscription/select' });

	const [subscriptionState, setSubscriptionState] = useState<SubscriptionState>({ isLoaded: false, subscriptionPlans: [] });

	useEffect(
		() => {
			SubscriptionService.plans()
				.then(result => setSubscriptionState({ isLoaded: true, subscriptionPlans: createPlansViewModels(result) }))
				.catch(() => alert('не удалось загрузить данные, попробуйти обновить страницу'));
		},
		[]);

	if (!subscriptionState.isLoaded)
		return <LoadingComponent />;
	
	return (
		<SiteLayoutComponent activeSection={SiteSection.None}>
			<SubscriptionSelectLayout subscriptionPlans={subscriptionState.subscriptionPlans} />
		</SiteLayoutComponent>
	);
}